// `*_on_white_bg` styles are for white surfaces (modal panels, white cards); their counterparts without
// the suffix use the bright primary color and are for dark backgrounds. See packages/ui/src/tailwind/README.md.
export enum ButtonStyle {
    /** Bright `--primary-color` fill, dark backgrounds only. Also what a `<Button>` without `style` renders. On white use `default_on_white_bg`. */
    default = 'default',
    /** Primary CTA on white surfaces (modals, white cards): `--primary-middle-color` fill. */
    default_on_white_bg = 'default_on_white_bg',
    /** `default` without horizontal padding, dark backgrounds only. On white use `default_no_padding_on_white_bg`. */
    default_no_padding = 'default_no_padding',
    /** `--primary-color` text, dark backgrounds only. On white use `frameless_on_white_bg`. */
    frameless = 'frameless',
    /** Frameless on white surfaces: `--primary-dark-color` text. */
    frameless_on_white_bg = 'frameless_on_white_bg',
    /** `--primary-color` text with a primary fill on hover, dark backgrounds only. On white use `inverted_on_white_bg`. */
    inverted = 'inverted',
    /** Inverted on white surfaces: `--on-primary-color` text with a `--primary-middle-color` fill on hover. */
    inverted_on_white_bg = 'inverted_on_white_bg',
    /** `--primary-color` border and text, dark backgrounds only. On white use `outlined_on_white_bg`. */
    outlined = 'outlined',
    /** Outlined on white surfaces: `--primary-dark-color` border and text, `--primary-middle-color` fill on hover. */
    outlined_on_white_bg = 'outlined_on_white_bg',
    outlined_on_surface = 'outlined_on_surface',
    /** Gray border and text on white surfaces. */
    outlined_gray_on_white_bg = 'outlined_gray_on_white_bg',
    outlined_no_padding = 'outlined_no_padding',
    gray_and_white = 'gray_and_white',
    gray_and_white_no_padding = 'gray_and_white_no_padding',
    event_request_status_button = 'event_request_status_button',
    text_only = 'text_only',
    text_only_no_padding = 'text_only_no_padding',
    ghost = 'ghost',
    delete_action = 'delete_action',
    destructive = 'destructive',
    /** `default_on_white_bg` without padding: `--primary-middle-color` fill. */
    default_no_padding_on_white_bg = 'default_no_padding_on_white_bg',
    cyan_on_dark_bg = 'cyan_on_dark_bg',
    light_gray = 'light_gray',
    text_on_surface = 'text_on_surface',
    surface = 'surface'
}
